import { render } from "./BaseContentWrapper.vue?vue&type=template&id=8407a02a"
import script from "./BaseContentWrapper.vue?vue&type=script&lang=js"
export * from "./BaseContentWrapper.vue?vue&type=script&lang=js"

import "./BaseContentWrapper.vue?vue&type=style&index=0&id=8407a02a&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__